module.exports = __webpack_public_path__ + "img/live-red.808d884d.svg";